/* eslint-disable no-await-in-loop */
import { NSW_STATUS } from '@src/constants/pronunciationCheck';
import api from './api';

const INITIAL_POLL_INTERVAL = 1000;
const MAX_POLL_INTERVAL = 16 * 1000; // 16 seconds
const MAX_POLL_TIMEOUT = 5 * 60 * 1000; // 5 minutes

const submitPronunciationCheck = async (text, voiceCode, signal) => {
  const response = await api.post('/nsw', { text, voiceCode }, { signal });
  return response;
};

const getPronunciationResult = async (requestId, signal) => {
  const response = await api.get(`/nsw/${requestId}`, {
    signal,
  });
  return response;
};

// ============================================================
// Polling wrapper
// ============================================================

const createPollPronunciationResult =
  (getResult) => async (requestId, signal) => {
    const startTime = Date.now();
    let interval = INITIAL_POLL_INTERVAL;

    while (Date.now() - startTime < MAX_POLL_TIMEOUT) {
      if (signal?.aborted) {
        throw new DOMException('Aborted', 'AbortError');
      }

      const response = await getResult(requestId, signal);

      if (
        response?.status === 0 ||
        response?.result?.nswRequest?.status === NSW_STATUS.FAILURE
      ) {
        throw new Error(response.errorMessage || 'Pronunciation check failed');
      }

      if (NSW_STATUS.SUCCESS === response?.result?.nswRequest?.status) {
        return response;
      }

      const currentInterval = interval;
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve, reject) => {
        const timer = setTimeout(resolve, currentInterval);
        signal?.addEventListener(
          'abort',
          () => {
            clearTimeout(timer);
            reject(new DOMException('Aborted', 'AbortError'));
          },
          { once: true },
        );
      });

      interval = Math.min(interval * 2, MAX_POLL_INTERVAL);
    }

    throw new Error('Pronunciation check timeout');
  };

const pollPronunciationResult = createPollPronunciationResult(
  getPronunciationResult,
);

export {
  submitPronunciationCheck,
  getPronunciationResult,
  pollPronunciationResult,
};
